import styled from './criarsenha.module.css';
import { CiLock, CiUnread, CiRead } from 'react-icons/ci';
import { useState,useContext } from 'react';
import {AuthContext} from '../../services/global';
import {useNavigate} from 'react-router-dom';
import api from '../../services/api';
import {Alerta} from '../../utils/functions';


function CriarSenha() {
    const [ver, setVer] = useState(false);
    const [ver1, setVer1] = useState(false);
    const { setStatus,cgcglobal } = useContext(AuthContext);
    const Navigate = useNavigate();
    const [sencli,setSencli] = useState('');
    const [sencli1,setSencli1] = useState('');
    
    
    //Criando senha**************************************************
    async function CriarSenha() {
        await api.get(`gerasenha/?cgccli=${cgcglobal}&sencli=${sencli1}`)
        .then((response)=>{
            if(!response.data.msg){
                setStatus('sucesso');
                Navigate('/Sucessosenha');
            }else{
               setSencli('');
               setSencli1('');
               Alerta('Erro!',response.data.msg,'error');
            }
        }).catch((erro)=>{
            setSencli('');
            setSencli1('');
            Alerta('Erro!',erro,'error');
        })
      
    }
    //*************************************************************** */


    return (
        <div className={styled.pagelogin}>
            <div className={styled.container}>
                <div className={styled.logo}>
                    <div className={styled.logoimg}></div>
                </div>
                <div className={styled.card}>
                    <div className={styled.cardheader}>
                        <div className={styled.cardtitle}>
                            <a className={styled.titletext}>Estamos quase lá...</a>
                            <div className={styled.titletextline}></div>
                        </div>
                    </div>
                    <div className={styled.cardcontent}>
                        <div className={styled.app}>
                            <a className={styled.titletext2}>Agora precisamos que você crie uma senha para acessar a área do cliente Cozimax.</a>
                            <div className={styled.frame100}>
                                <div className={styled.frame101}>
                                    <div className={styled.frame102}>
                                        <label>Senha <a>*</a></label>
                                        <div className={styled.password}>
                                            <CiLock className={styled.fieldusericon} />
                                            {ver == false ?
                                                <input type='password' value={sencli} onChange={(e)=>setSencli(e.target.value)}/>
                                                :
                                                <input type='text' value={sencli} onChange={(e)=>setSencli(e.target.value)}/>
                                            }
                                            {ver == false ?
                                                <CiUnread onClick={() => setVer(true)} size={24} />
                                                :
                                                <CiRead onClick={() => setVer(false)} size={24} />
                                            }
                                        </div>
                                    </div>
                                    <div className={styled.frame103}>
                                        <a>No minimo 8 caracteres</a>
                                    </div>
                                </div>
                                {/*
                                <div className={styled.level}>
                                    <div className={styled.level1}>
                                        <div className={styled.bar1}></div>
                                        <div className={styled.bar2}></div>
                                        <div className={styled.bar3}></div>
                                    </div>
                                    <a>Fraca</a>
                                </div>
                                */}
                            </div>
                            <div className={styled.frame200}>
                                <div className={styled.frame101}>
                                    <div className={styled.frame102}>
                                        <label>Repetir Senha <a>*</a></label>
                                        <div className={styled.password}>
                                            <CiLock className={styled.fieldusericon} />
                                            {ver1 == false ?
                                                <input type='password' value={sencli1} onChange={(e)=>setSencli1(e.target.value)} />
                                                :
                                                <input type='text' value={sencli1} onChange={(e)=>setSencli1(e.target.value)} />
                                            }
                                            {ver1 == false ?
                                                <CiUnread onClick={() => setVer1(true)} size={24} />
                                                :
                                                <CiRead onClick={() => setVer1(false)} size={24} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div onClick={()=>CriarSenha()} className={styled.btn}>CADASTRAR SENHA</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default CriarSenha;